import axios from 'axios'
import { API_URL } from '@/config/api.config'

const campAPI = {
    /**
     * 获取营地列表
     */
    getCampList: async (params) => {
        try {
            const response = await axios.get(`${API_URL}/camp`, { params });
            return response.data;
        } catch (error) {
            console.error('获取营地列表失败:', error);
            throw error;
        }
    },

    /**
     * 获取设施
     */
    getFacility: async () => {
        try {
            const response = await axios.get(`${API_URL}/facility`);
            return response.data;
        } catch (error) {
            console.error('获取设施列表失败:', error);
            throw error;
        }
    },
    
    /**
     * 新增营地
     */
    createCamp: async (campData) => {
        try {
            const response = await axios.post(`${API_URL}/camp`, campData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('新增营地失败:', error);
            throw error;
        }
    },
    
    /**
     * 编辑更新营地
     */
    updateCamp: async (id, campData) => {
        try {
            const response = await axios.put(`${API_URL}/camp/${id}`, campData);
            return response.data;
        } catch (error) {
            if (error.response) {
            } else if (error.request) {
                console.error('未收到服务器响应');
            } else {
                console.error('请求配置错误:', error.message);
            }
            throw error;
        }
    },
    
    /**
     * 删除营地
     */
    deleteCamp: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/camp/${id}`);
            return response.data;
        } catch (error) {
            console.error('删除营地失败:', error);
            throw error;
        }
    },

    /**
     * 获取营地详情
     */
    getCampDetail: async (id) => {
        try {
          const response = await axios.get(`${API_URL}/camp/${id}`);
          return response.data;
        } catch (error) {
          console.error('获取营地详情失败:', error);
          throw error;
        }
    },

    /**
    * 获取营地类型
    */
    getCampType: async () => {
        try {
            const response = await axios.get(`${API_URL}/camp-type`);
            return response.data;
        } catch (error) {
            console.error('获取营地类型失败:', error);
            throw error;
        }
    },
    

    /**
     * 获取营地标签
     */
    getCampTag: async () => {
        try {
            const response = await axios.get(`${API_URL}/camp-tag`);
            return response.data;
        } catch (error) {
            console.error('获取营地标签失败:', error);
            throw error;
        }
    },

    
    /**
     * 更新营地状态
     */
    updateCampStatus: async (id, isActive) => {
        try {
            const response = await axios.put(`${API_URL}/camp/${id}/status`, { is_active: isActive });
            return response.data;
        } catch (error) {
            console.error('更新营地状态失败:', error);
            throw error;
        }
    }};
  
  export default campAPI;